/**
 * Rótulos legíveis dos campos da narrativa do laudo (E23.F8). // ux-neutrality:allow doc-comment
 *
 * Compartilhado entre a pré-visualização, o card de proposta e o histórico // ux-neutrality:allow doc-comment
 * para um único ponto de tradução campo→rótulo. // ux-neutrality:allow doc-comment
 */
import { ptBR } from '@/i18n/pt-BR';

const FIELD_LABELS: Readonly<Record<string, string>> = {
  estrutura_geral: ptBR.laudoCaso.narrative.fields.estrutura_geral,
  morfologia: ptBR.laudoCaso.narrative.fields.morfologia,
  conectividade: ptBR.laudoCaso.narrative.fields.conectividade,
  inclinacao: ptBR.laudoCaso.narrative.fields.inclinacao,
  sequencia: ptBR.laudoCaso.narrative.fields.sequencia,
  avaliacao_tecnica: ptBR.laudoCaso.narrative.fields.avaliacao_tecnica,
  sintese: ptBR.laudoCaso.narrative.fields.sintese,
  observacao_adicional: ptBR.laudoCaso.narrative.fields.observacao_adicional,
  convergencias: ptBR.laudoCaso.narrative.convergenciasLabel,
  divergencias: ptBR.laudoCaso.narrative.divergenciasLabel,
};

export function narrativeFieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? field;
}
